export enum Routes {
    Login = '/login',
    Home = `/home/orders`,
    Forthcoming = `/home/forthcoming`,
    Displayer = `/home/displayer`,
    History = `/home/history`,
    CustomerDisplay = `/customer-display`,
}
